import api from '../api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { ApiRouteEnum } from '../../enums/ApiRouteEnum'

export const usePostFlexiGroupRemoveMember = (
  successCallBack: (data: any) => void,
  errorCallBack: (data: any) => void,
) => {
  const queryClient = useQueryClient()
  return useMutation(
    ({flexiGroupId, memberId}: {flexiGroupId: string, memberId: any}) =>
      api.patch(ApiRouteEnum.FLEXI_REMOVE_MEMBER , {
        user: memberId,
        flexiGroup: parseInt(flexiGroupId)
      }),
    {
      onSuccess: (data) => {
        queryClient.invalidateQueries([ApiRouteEnum.ORGANIZATION])
        queryClient.invalidateQueries([ApiRouteEnum.USER])
        successCallBack(data.data)
      },
      onError: (error) => errorCallBack(error),
    },
  )
}
